import { Booking as ApiBooking } from '../../../types/Booking';
import apiCall from '../../apiCall/apiCall';

type ApiBookingResponse = { data: ApiBooking };

class Booking {
  static create(booking: ApiBooking): Promise<ApiBookingResponse> {
    return apiCall('POST', 'bookings', {
      booking,
    }) as Promise<ApiBookingResponse>;
  }
}

export default Booking;
